// =============================================================================
// The small round avatar shown next to events, comments and participants —
// photo, emoji or initial on the member's colour. A plain render function
// (not a component) so callers keep passing it around as `renderAvatar`.
// =============================================================================

import React from 'react';
import { AVATAR_COLORS } from '../../lib/profile';

// `m` is the resolved profile-like member object, or null when unknown.
export const renderMemberAvatar = (m, size = 22) => {
  const color =
    AVATAR_COLORS.find((c) => c.id === m?.avatarColor) || AVATAR_COLORS[0];
  const name = m?.displayName || '?';
  const initial = name.trim().charAt(0).toUpperCase() || '?';
  if (m?.avatarKind === 'photo' && m.avatarUrl) {
    return (
      <img
        src={m.avatarUrl}
        alt=""
        title={name}
        className="rounded-full object-cover flex-shrink-0"
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      title={name}
      className="rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0"
      style={{ width: size, height: size, backgroundColor: color.swatch, fontSize: size * 0.45 }}
    >
      {m?.avatarEmoji ? (
        <span style={{ fontSize: size * 0.6, lineHeight: 1 }}>{m.avatarEmoji}</span>
      ) : (
        initial
      )}
    </div>
  );
};
